/* ══════════════════════════════════════════════════════════════════
   Zweimal gedrückt ist einmal gemeint.

   Playbook-Durchgang 03.10.2026: Ein Doppelklick auf „Kunde anlegen" legte
   zwei Kunden an, beide am selben Lexware-Kontakt (K-01); „Anlegen" bei der
   Gerätegruppe legte zwei Gruppen an (S-01); „Zum Kunden machen" doppelt
   getippt zeigte „Das gibt es nicht mehr" (K-14); ein Doppeltipp auf
   „Übergabe bestätigen" schickte eine zweite Eintragung, die als Abweisung
   in der Glocke landete (D-20).

   Die Knöpfe sperrten sich zwar — aber über `isPending`, und das kommt erst
   mit dem nächsten Zeichnen. Ein Doppelklick ist schneller. Die Sperre muss
   **im Klick selbst** sitzen, nicht im Zustand danach.

   Zwei Riegel, beide rein, damit sie sich prüfen lassen:

   - `doppelterDruck` — ein Hauptknopf (`Knopf art="haupt"`) nimmt binnen
     einer Sekunde nach dem ersten Druck keinen zweiten an. Länger wartet
     niemand, der zweimal drücken *will*; kürzer ist jeder Doppelklick.
   - `stehtSchon` — kommt eine Übergabe trotzdem zweimal an, und der Server
     sagt „für diese Belegung gibt es das Protokoll schon", dann **steht**
     sie. Das ist kein fachliches Nein und gehört nicht in die Glocke.
   ══════════════════════════════════════════════════════════════════ */

/** Wie lange nach einem Druck ein zweiter nicht zählt. */
export const DOPPELDRUCK_MS = 1000;

/** War das der zweite Druck eines Doppelklicks? `letzter` ist der zuletzt angenommene. */
export function doppelterDruck(letzter: number | null, jetzt: number, fenster = DOPPELDRUCK_MS): boolean {
  return letzter !== null && jetzt - letzter >= 0 && jetzt - letzter < fenster;
}

/**
 * **Ein 404 auf das eigene Löschen ist ein Ja** (AG-29, Durchgang
 * 03.10.2026). „Entwurf verwerfen" doppelt geklickt: das erste `DELETE` 200,
 * das zweite 404 — und die Maske zeigte „Vielleicht hat es jemand anders
 * gelöscht". Wer etwas weghaben will und hört „gibt es nicht", hat, was er
 * wollte.
 */
export function schonWeg(fehler: unknown): boolean {
  return typeof fehler === "object" && fehler !== null
    && (fehler as { status?: unknown }).status === 404;
}

/** Der eindeutige Schlüssel „ein Protokoll je Belegung und Art" (handover). */
const PROTOKOLL_JE_BELEGUNG = "handover_tenant_id_booking_id_kind_key";

/**
 * Ist diese Abweisung in Wahrheit „schon da"? Nur für das Protokoll: Die
 * Übergabe einer Belegung gibt es genau einmal, und wenn der Server sagt,
 * dass sie steht, dann steht sie — die Eintragung auf dem Telefon ist
 * erledigt, nicht abgewiesen.
 */
export function stehtSchon(
  fehler: { schluessel: string; daten?: Record<string, unknown> } | null | undefined,
  art: string,
): boolean {
  return art === "protokoll"
    && fehler?.schluessel === "bereits_vorhanden"
    && fehler.daten?.["regel"] === PROTOKOLL_JE_BELEGUNG;
}
